module.exports = __webpack_public_path__ + "static/aus_boys_bottom_payoff_1600px2-9bd7a96e42629f489942c4cbc97a7160.jpg";